/**
 * Unread badge count: exact 1–9, or 9+ from 10.
 */
import * as React from 'react';
import { cn } from '@/lib/utils';
import { getNotificationBadgeDisplay } from '@/components/notifications/notification-utils';

/** Props for {@link NotificationBadgeCount}. */
type Props = Readonly<{
  count: number;
  className?: string;
  plusClassName?: string;
}>;

/** Unread-count badge; shows `9+` when the count exceeds nine. */
export const NotificationBadgeCount: React.FC<Props> = ({ count, className, plusClassName }) => {
  const display = getNotificationBadgeDisplay(count);
  if (display.kind === 'exact') {
    return <span className={className}>{display.text}</span>;
  }
  return (
    <span className={cn('notification-badge-count', className)}>
      9<span className={cn('notification-badge-plus', plusClassName)}>+</span>
    </span>
  );
};
